import * as marietta from '../..';

class SVGUtil {
  /**
     * SVGのライン記述を返す
     * @param Point 始点
     * @param Point 終点
     */
  static getPathLineString(p1: marietta.core.Point, p2: marietta.core.Point): string {
    const retString: string = `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y}`;
    return retString;
  }

  /**
    * SVGのPath記述を返す
    * @param Point 始点
    * @param Point 終点
    */
  static getPathString(dotInfo: any): string {
    let retString: string = 'M ';
    retString += `${dotInfo[0].x} ${dotInfo[0].y}`;
    for (let i: number = 1; i < dotInfo.length; i += 1) {
      retString += ` L ${dotInfo[i].x} ${dotInfo[i].y}`;
    }
    return retString;
  }

  /**
   * SVGのPath記述を返す
   * @param Point 始点
   * @param Point 終点
   */
  static getPathStringWithTranslate(dotInfo: any, translateX:number = 0, translateY:number = 0 ): string {
    let retString: string = 'M ';
    retString += `${dotInfo[0].x + translateX} ${dotInfo[0].y + translateY}`;
    for (let i: number = 1; i < dotInfo.length; i += 1) {
      retString += ` L ${dotInfo[i].x + translateX} ${dotInfo[i].y + translateY}`;
    }
    return retString;
  }

  /**
     * 線色を変更する
     * param element Element ie spt.element
     * param stroke string ie #FF0000
     * */
  static changeStrokeColor(element: Element, color: string): void {
    const allPaths: Element[] = [];
    let parts: any;
    let k: number;

    // ビュー要素の中のpathを全て集める
    if ((element).querySelectorAll('path').length) {
      parts = (element).querySelectorAll('path');
      for (k = 0; k < parts.length; k += 1) {
        allPaths.push(parts[k]);
      }
    }

    // ビュー要素の中のパスのstrokeの色を全部変更する
    for (let i: number = 0; i < allPaths.length; i += 1) {
      if ((allPaths[i] as Element).hasAttribute('stroke') && (allPaths[i] as Element).getAttribute('stroke') !== 'none') {
        (allPaths[i] as Element).setAttribute('stroke', color);
      }
    }
  }
}
export default SVGUtil;
